import React, { useEffect, useState } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getAllSessionsandEvents } from "../../services/CareTeam";

const ViewCareTeamBox = ({teamData}) => {
  const navigate = useNavigate()
  const [appointmentList, setAppointmentList] = useState([])
  
  useEffect(() => {
    const getAllSessionsEvents = async () => {
      try {
        const result = await getAllSessionsandEvents('all',teamData._id);

        if (result.status !== 200) return;
        setAppointmentList(result.data.data);
      } catch (error) {
        console.log(error);
      }
    };

   if(teamData._id){
    getAllSessionsEvents();
   }
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <div className="careteam_box carebox_back5 text-center ">
            <h1 className="labelFont">{appointmentList?.length}</h1>
            <h5 className="headFont">Appointments</h5>
          </div>
        </div>
        <div className="col-md-3">
          <div className="careteam_box carebox_back6 text-center ">
            <h1 className="labelFont">5K</h1>
            <h5 className="headFont">Total Patients</h5>
          </div>
        </div>
        <div className="col-md-3">
          <div className="careteam_box carebox_back7 text-center"
          onClick={() => navigate("/viewcareteamgroups", {state:{careId:teamData._id}})}
          >
            <h1 className="labelFont">{teamData?.groups?.length}</h1>
            <h5 className="headFont">Groups</h5>
            <div className="text-end">
              <MdArrowForwardIos className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="careteam_box carebox_back8 text-center " 
          onClick={() => navigate("/viewcareteamprograms", {state:{careId:teamData._id}})}>
            <h1 className="labelFont">{teamData?.programs?.length}</h1>
            <h5 className="headFont">Programs</h5>
            <div className="text-end">
              <MdArrowForwardIos className="icon me-4 mt-3" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCareTeamBox;
